module.exports = __webpack_public_path__ + "static/media/asv_bloc1-min.f42038b1.png";